<template>
    <div :class="{'is-invalid': !valid}">
        <v-select :options="formatted" :multiple="multiple" :searchable="searchable" v-model="selection" :clearable="true">
            <template v-slot:no-options>
                Helaas geen data gevonden.
            </template>

            <template #search="{ attributes, events }">
                  <input
                    ref="input"
                    class="vs__search"
                    data-silent
                    :name="name"
                    v-bind="attributes"
                    v-on="events"
                    @is-invalid="valid=false"
                    @is-valid="valid=true"
                  />
              </template>
        </v-select>
        <div class="c-form__error" :class="{'c-form__error--show': !valid}">Dit veld is verplicht.</div>
    </div>
</template>

<script>
import VSelect from 'vue-select';

export default {
    components: { VSelect },
    props: {
        options: {
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        searchable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        value: {
            required: false
        },
        name: {
            type: String,
            required: false
        },
        validator: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            valid: true,
            selection: []
        }
    },
    computed: {
        formatted() {
            let data = [];

            Object.keys(this.options ?? {}).forEach( (id) => {
                data.push({code: id, label: this.options[id]});
            });

            return data
        }
    },
    watch: {

        value() {
            this.selection = this.value;
        },

        selection() {
            this.$emit('input', this.selection);
        }
    },
    methods: {
        validate(component) {

            return ( !component.required
                    || ( component.multiple && component.selection.length )
                    || ( !component.multiple && component.selection )
                );
        }
    },
    mounted() {
        this.$refs.input.validation = () => {
            return this.validate(this);
        };
    },
    created() {
        this.selection = this.value;
    }
}
</script>
